import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Api from 'services/Api';
import Countdown from 'components/Countdown';
import FlipClock from 'components/FlipClock';
import Carousel from 'modules/Carousel';
import Bingo from 'modules/Bingo';
import Button from 'components/Button';
import './ticketInfo.css';

const SECOND = 1000;

export const _TicketInfoPanel = ({
  refName,
  ticketCount,
  showBuy,
  startDate,
  updateStartDate,
  inPlay,
  inProgress,
  freeRoom,
  maxPurchaseCount
}) =>
  refName ? (
    <div className="ticketInfoPanel">
      {inPlay || inProgress ? (
        <Countdown expirationDate={startDate} onEnd={updateStartDate} updateInterval={SECOND}>
          <FlipClock />
        </Countdown>
      ) : null}
      <span className="title">Your tickets for next game:</span>
      <div className="ticketCount-box">{ticketCount}</div>
      <Button
        className="ticketBuy"
        name="ticketBuy"
        id="ticketInfoPanel-ticketBuy"
        buttonText={
          maxPurchaseCount === 0
            ? 'You have all tickets!'
            : freeRoom
            ? 'Claim tickets'
            : ticketCount === 0
            ? 'Buy tickets'
            : 'Buy more tickets'
        }
        onClick={showBuy}
        disabled={maxPurchaseCount === 0}
      />
    </div>
  ) : null;

_TicketInfoPanel.propTypes = {
  refName: PropTypes.string.isRequired,
  nextAvailableRefs: PropTypes.arrayOf(PropTypes.string),
  ticketCount: PropTypes.number,
  inProgress: PropTypes.bool,
  freeRoom: PropTypes.bool,
  inPlay: PropTypes.bool,
  showBuy: PropTypes.func
};

_TicketInfoPanel.defaultProps = {
  ticketCount: 0,
  nextAvailableRefs: null,
  showBuy: null,
  inPlay: false,
  freeRoom: false,
  inProgress: false
};

const mapStateToProps = (state, ownProps) => {
  const { refName } = ownProps;
  const roomProps = Bingo.selectors.getDisplayProps(state);
  const { freeRoom } = roomProps || {};
  const startDate = Bingo.selectors.getNextStartDate(state, refName);
  const nextAvailableCount = Bingo.selectors.getAvailableTicketCount(state, refName, 'next');
  const nextAvailableRefs = Bingo.selectors.getAvailableTicketRefs(state, refName, 'next');
  const nextPurchasedRefs = Bingo.selectors.getPurchasedTicketRefs(state, refName, 'next');
  const curPurchasedRefs = Bingo.selectors.getCurrentPurchasedTicketRefs(state, refName, 'current');
  const inPlay = Bingo.selectors.getInPlay(state);
  const maxPurchaseCount = (nextAvailableRefs && nextAvailableRefs.length) || nextAvailableCount;
  return {
    freeRoom: freeRoom,
    maxPurchaseCount: maxPurchaseCount,
    startDate: (startDate && new Date(startDate).getTime()) || Date.now(),
    inPlay: inPlay,
    inProgress: Bingo.selectors.getInProgress(state),
    ticketCount: inPlay
      ? curPurchasedRefs && curPurchasedRefs.length
      : nextPurchasedRefs && nextPurchasedRefs.length
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  showBuy: () => dispatch(Carousel.actions.selectBottom('bingoMiddleMobile', 'buyTickets')),
  updateStartDate: () =>
    Api.actions.bingo.startDate({ refName: ownProps.refName, instance: 'next' }, undefined, {
      skipSession: true
    })(dispatch)
});

// PureComponent: SIMPLE props only, ALL children must be PURE too!
export default connect(mapStateToProps, mapDispatchToProps)(_TicketInfoPanel);
